import { gql } from "@apollo/client";

/**
 * Write the invitations a campaign just sent to the outreach log, so a campaign
 * leaves the same trail every other outreach tool leaves.
 */
export const RECORD_CAMPAIGN_INVITES = gql`
  mutation adminRecordCampaignInvites(
    $campaign: InviteCampaignKey!
    $eventId: String!
    $userIds: [String!]!
  ) {
    adminRecordCampaignInvites(campaign: $campaign, eventId: $eventId, userIds: $userIds)
  }
`;

/** What the campaign achieved, week by week, for events already held. */
export const CAMPAIGN_RESULTS = gql`
  query adminCampaignResults($campaign: InviteCampaignKey!, $from: Date, $to: Date) {
    adminCampaignResults(campaign: $campaign, from: $from, to: $to) {
      weekStarting
      events
      invited
      saidYes
      came
      totalThere
      partial
    }
  }
`;

/** The events behind one week — loaded when that week is opened. */
export const CAMPAIGN_EVENT_RESULTS = gql`
  query adminCampaignEventResults($campaign: InviteCampaignKey!, $weekStarting: Date!) {
    adminCampaignEventResults(campaign: $campaign, weekStarting: $weekStarting) {
      eventId
      title
      startDate
      invited
      saidYes
      came
      totalThere
    }
  }
`;

export const INVITE_CAMPAIGN = gql`
  query adminInviteCampaign($campaign: InviteCampaignKey!) {
    adminInviteCampaign(campaign: $campaign) {
      zone
      programme
      eventId
      eventTitle
      eventStartDate
      memberCount
      members {
        userId
        email
        firstName
        isGuest
        why
        note
        afterPass
        option
      }
      extraMembers {
        userId
        email
        firstName
        isGuest
        why
        note
        afterPass
        option
      }
    }
  }
`;
